module.exports = __webpack_public_path__ + "static/media/Expired_Prospects.67685c5e.mp4";